/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sour_Giant_Buzzard_SlurpInputs */

const fr_sour_giant_buzzard_slurp = /** @type {(inputs: Sour_Giant_Buzzard_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**

* @param {Sour_Giant_Buzzard_SlurpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sour_giant_buzzard_slurp = /** @type {((inputs?: Sour_Giant_Buzzard_SlurpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sour_Giant_Buzzard_SlurpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sour_giant_buzzard_slurp(inputs)
});